import { ActionTypes } from '../actions/types';
import { resetAuftragserfassung } from '../actions/auftragserfassung';

const initialState = {
  benutzerliste: [],
  reloadToggle: false,
  totalSearchResults: undefined,
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.GET_BENUTZERLISTE: {
      return {
        ...state,
        benutzerliste: payload,
      };
    }
    case ActionTypes.RELOAD_USERMANAGEMENT: {
      resetAuftragserfassung();
      return {
        ...state,
        reloadToggle: !state.reloadToggle,
      };
    }
    case ActionTypes.SET_TOTALSEARCHRESULTS: {
      return {
        ...state,
        totalSearchResults: payload,
      };
    }
    default:
      return state;
  }
  return state;
}
